<mat-card appearance="outlined" class="report-card-shell" [ngClass]="setClass() " (click)="openReportDetails()">
  <mat-card-header style="padding: 0px;">
    <!-- <img mat-card-avatar  [src]="'../../assets/img/' + this.Report.PlayerCurrentTeamIcon"     > -->
    <table>
      <tr>
        <td>
          @if (this.Report.PlayerCurrentTeamIcon!=null) {
            <img style="max-height: 40px; max-width: 70px;" [src]="('/assets/img/' + this.Report.PlayerCurrentTeamIcon).replace('//','/').toLowerCase()"     >
          }
        </td>
        <td>
          <a style="font-size: 14px; " class="gamelink" [routerLink]="['/player/details', this.Report.PlayerId]"> 
          {{ this.Report.PlayerLastName}}, {{ this.Report.PlayerFirstName}}
         </a>
        <div style="font-size: 10px; ">
          @if (this.Report.PositionId===1) {
            <span>
              Goaltender -
            </span>
          }
          @if (this.Report.PositionId===2 || this.Report.PositionId===3 ) {
            <span >
              Defender -
            </span>
          }
          @if (this.Report.PositionId>3) {
            <span>
              Forward -
            </span>
          }
          <span >

            {{ this.Report.DateOfBirth | date:'yyyy-MM-dd'}} ({{this.Report.PlayerAgeYear + ' Years ' + this.Report.PlayerAgeMonth + ' Months'}})

          </span>
          <br>
            @if (this.Report.ReportDivision != null && this.Report.ReportTeamName != null) {
              <span>
                {{(this.Report.ReportDivision ) + "/" + this.Report.ReportTeamName}}<br/>
              </span>
            }
            @if (this.Report.ReportDivision === null || this.Report.ReportTeamName === null) {
              <span>
                {{(this.Report.PlayerCurrentDivision) + "/" + this.Report.PlayerCurrentTeam}}<br/>
              </span>
            }

          </div>






        </td>
      </tr>
    </table>



  </mat-card-header>
  <mat-card-content style="margin-bottom: 0px;" >
    <!-- <mat-divider></mat-divider> -->
     <label style="font-size: 10px; ">{{'SCOUTING.COMMENT' | translate}}</label>

    <div style="font-size: 11px; padding: 5px;min-height: 50px; white-space: pre-line;">
      {{displayText}}
      @if (isTextTruncated) {
        <a class="gamelink" style="font-size: 11px; white-space: nowrap;" (click)="toggleTextExpanded($event)">
          {{ (isTextExpanded() ? 'GENERAL.SHOW_LESS' : 'GENERAL.SHOW_MORE') | translate }}
        </a>
      }
    </div>
    
    <app-report-overall-grades 
    [PositionId]="this.Report.PositionId" [PositionText]="this.Report.PositionText"
    [TotalQualityText]="this.Report.TotalQualityText" [TotalQuality]="this.Report.TotalQuality"
    [GamePerformanceText]="this.Report.GamePerformanceText" [GamePerformance]="this.Report.GamePerformance" 
    [CapacityText]="this.Report.PlayerCapacityText"  [Capacity]="this.Report.PlayerCapacity"
    [PlayerTypeText]="this.Report.PlayerTypeText" [PlayerType]="this.Report.PlayerType" 
    [CurrentLevelRankingText]="this.Report.CurrentLevelRankingText" [CurrentLevelRanking]="this.Report.CurrentLevelRanking">
    </app-report-overall-grades>


    <div style="font-family: Rubik; text-align: left; vertical-align: top;  padding: 0; white-space: normal; margin: 0;  ">
      <table>
        @if (this.Report.GameText) {
          <tr>
            <td>
              <mat-icon style="font-size: 18px; height: 19px;">sports_hockey</mat-icon>
            </td>
            <td>
              <div style="font-size: 10px;">
                <a [routerLink]="['/scouting/gamedetails', this.Report.GameId]" class="gamelink">
                  <label>{{this.Report.GameText}} </label>    <br>
                </a>
                <span>{{this.Report.ReportDivision}} - {{this.Report.GameDate | date:'yyyy-MM-dd'}}</span>
              </div>
            </td>
          </tr>
        }

        <tr>
          <td>

            <mat-icon style="font-size: 18px; height: 19px;"> location_on</mat-icon>
          </td>
          <td>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 10px;">              
              <div style="font-size: 10px;">
                {{this.Report.Location}}
              </div>
              @if(this.Report.ScoutingSourceId!=0) {
              <div class="source">       
                {{this.Report.ScoutingSourceText}}
              </div>
              }
            </div>
            
          </td>
        </tr>
        <tr>
          <td>
            <mat-icon style="font-size: 18px; height: 19px;">person</mat-icon>
          </td>
          <td>
            <div style="font-size: 10px;">{{this.Report.CreatedByLastName}}, {{this.Report.CreatedByFirstName}}  <span style="color: gray;font-size: 10px; color: darkgray;">- {{getTimeAgo()}} ({{this.Report.DateCreated | date:'yyyy-MM-dd HH:mm' }})</span></div>

          </td>
        </tr>


      </table>



    </div>






  </mat-card-content>
  <!-- <mat-card-actions>

    <a id="2" mat-icon-button (click)="gotoPlayerDetails(this.Report.PlayerId)" c >
      <mat-icon>person</mat-icon>

     
    </a>
    <a id="222" mat-icon-button (click)="gotoReportDetails(this.Report.ReportId)" c >
      <mat-icon>view</mat-icon>

     
    </a>
    @if (this.Report.GameId) {
      <a id="22" mat-icon-button    [routerLink]="[ '/scouting/gamedetails', this.Report.GameId ]">
        <mat-icon>sports_hockey</mat-icon>
        
      </a>
    }
    @if (this.Report.IsCreatedByCurrentUser) {
      <a id="1" mat-icon-button [routerLink]="['/scouting/editreport', this.Report.ReportId]" >
        <mat-icon>edit</mat-icon>
      </a>
    }



  </mat-card-actions> -->
</mat-card>


